import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/**
 * Returns whether the signed-in user has paid, non-refunded access to the course.
 */
export const checkCourseAccess = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase } = context;
    const { data, error } = await supabase
      .from("purchases")
      .select("id, paid_at, refunded_at")
      .not("paid_at", "is", null)
      .is("refunded_at", null)
      .limit(1);
    if (error) {
      console.error("[access] checkCourseAccess query failed:", error);
      return { hasAccess: false };
    }
    return { hasAccess: (data?.length ?? 0) > 0 };
  });
